export default __webpack_public_path__ + "static/media/DNo.29-1.d592e755.jpg";